import { MyBreadcrumb } from "@/components/shared/layouts/myBreadcrumb";
import React from "react";

interface HeaderPageProps {
  children?: React.ReactNode;
}
const HeaderPage = ({ children }: HeaderPageProps) => {
  return (
    <section className="header-page h-80 flex flex-col items-center justify-center gap-4 text-center">
      <div className="text-white text-3xl uppercase">{children}</div>
      <MyBreadcrumb textColor="text-white" />
    </section>
  );
};

export default HeaderPage;
